import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetShiftList = createModule({
  base: 'GET_SHIFT_LIST', apiDetails: {...SERVICE_ENDPOINT.SHIFT, method: 'get'},
});

const AddShift = createModule({
  base: 'ADD_SHIFT', apiDetails: {...SERVICE_ENDPOINT.SHIFT, method: 'post'}, enableNotification: true, customNotificationSuccessMessage: 'Shift Created Successfully',
});

const UpdateShift = createModule({
  base: 'UPDATE_SHIFT', apiDetails: {...SERVICE_ENDPOINT.SHIFT, method: 'put'}, enableNotification: true, customNotificationSuccessMessage: 'Shift Updated Successfully',
});

const DeleteShift = createModule({
  base: 'DELETE_SHIFT', apiDetails: {...SERVICE_ENDPOINT.SHIFT, method: 'delete'}, enableNotification: true, customNotificationSuccessMessage: 'Shift Deleted Successfully',
});

export {
  GetShiftList, AddShift, UpdateShift, DeleteShift,
};
